<div
        [ngClass]="wrapperClasses"
        tabindex="0"
        class="full-width">
    <mat-label [ngClass]="{'required': input.required, 'edit-prompt': true}">{{input.label}}</mat-label>
    <ng-template #infoTemplate></ng-template>
    <div>{{input.control.value}}</div>
    <div class="has-max-chars" *ngIf="hasMaxChars">{{input.control?.value?.length ? input.control.value.length : 0}} / {{input.maxChars}}</div>
    <mat-error class="text-error">{{errorMessage}}</mat-error>
    <mat-hint [ngClass]="['text-hint', (hint?.class ? hint.class : '')]">{{hint?.message}}</mat-hint>
</div>